import { render, staticRenderFns } from "./HeroHome.vue?vue&type=template&id=3a7bc4ab&"
import script from "./HeroHome.vue?vue&type=script&lang=js&"
export * from "./HeroHome.vue?vue&type=script&lang=js&"
import style0 from "./HeroHome.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports